var render = function render(){var _vm=this,_c=_vm._self._c;return _c(this.item.children?.length ? 'Submenu' : 'MenuItem',{tag:"component",attrs:{"item":_vm.item,"path":_vm.path}},[(_vm.item.children?.length)?_vm._l((_vm.item.children),function(child){return _c('side-bar-item',{key:child.path,attrs:{"path":child.path,"item":child}})}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }